import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'izin';

var izinService = {
    belge: WsProvider.izin,
    gecmisIzinListesi(personelID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[personelID]': personelID,
            serviceName: moduleName,
            methodName: 'gecmisIzinListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinTanimla(form) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[personelID]': form.personelID,
            'data[baslangicTarihi]': form.izinTarihi[0],
            'data[izinTuru]': form.izinTuru,
            'data[bitisTarihi]': form.izinTarihi[1],
            'data[aciklama]': form.aciklama,
            'data[izinGunu]': form.dayInfo.izinGunu,
            'data[haftalikIzin]': form.dayInfo.haftalikIzin,
            'data[resmiTatil]': form.dayInfo.resmiTatil,
            'data[durum]': form.durum,
            'belge': form.belge[0].raw,
            serviceName: moduleName,
            methodName: 'ekle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinGuncelle(izinID, form) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[izinID]': izinID,
            'data[personelID]': form.personelID,
            'data[baslangicTarihi]': form.izinTarihi[0],
            'data[izinTuru]': form.izinTuru,
            'data[bitisTarihi]': form.izinTarihi[1],
            'data[aciklama]': form.aciklama,
            'data[izinGunu]': form.dayInfo.izinGunu,
            'data[haftalikIzin]': form.dayInfo.haftalikIzin,
            'data[resmiTatil]': form.dayInfo.resmiTatil,
            'data[durum]': form.durum,
            'belge': form.belge[0].raw,
            serviceName: moduleName,
            methodName: 'guncelle',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinDurumDegis(izinID, durum) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[izinID]': izinID,
            'data[durum]': durum,
            serviceName: moduleName,
            methodName: 'izinDurumDegistir',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinListesi(durum, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: moduleName,
            methodName: 'listele',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinSearch(durum, baslangic, limit, search) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': durum,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            'data[izinGunu]': '',
            'data[baslangicTarihi]': '',
            'data[bitisTarihi]': '',
            'data[adSoyad]': search.personelAdi,
            'data[izinTuru]': search.izinTuru,
            serviceName: moduleName,
            methodName: 'ara',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinDetay(izinID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[izinID]': izinID,
            serviceName: moduleName,
            methodName: 'detay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
    izinDosyaSil(dosyaID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[dosyaID]': dosyaID,
            serviceName: moduleName,
            methodName: 'dosyaSil',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
        return result;
    },
};
export default izinService;
